import { Injectable } from '@angular/core';
import { AppSettings } from '../../utils/app.settings';
import { Observable } from 'rxjs';
import { IConsuptionOptions } from '../../interfaces/consumption.interface';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IFineAdjustment } from '../../interfaces/fine-adjustment.interface';
import { IApplyFineAdjustment } from '../../interfaces/apply-fine-adjustment.interface';

@Injectable({
  providedIn: 'root',
})
export class FineAdjustmentService {
  constructor(
    private httpClient: HttpClient,
    private appSetting: AppSettings
  ) {}

  /**
   * Obtiene datos de ajuste fino con parámetros básicos
   * @param payload - Parámetros de consulta
   * @returns Observable con los datos de ajuste fino
   */
  getFineAdjustment(
    payload: IConsuptionOptions
  ): Observable<IFineAdjustment[]> {
    const url = `${this.appSetting.fineAdjustment.urls.base}?fechaInicio=${
      payload.startDate
    }&fechaFin=${payload.endDate}${
      payload.filters ? `&${payload.filters}` : ''
    }`;
    return this.httpClient.get<IFineAdjustment[]>(url);
  }

  /**
   * Aplica los ajustes finos a las predicciones seleccionadas
   * @param payload - Datos para aplicar el ajuste fino
   * @returns Observable con la respuesta del servidor
   */
  applyFineAdjustment(payload: IApplyFineAdjustment): Observable<any> {
    const url = this.appSetting.fineAdjustment.urls.base;
    return this.httpClient.post(url, payload);
  }
}
